import React from 'react';
import { ProductCard } from './ProductCard';
import { Skeleton } from '@/components/ui/skeleton';

export const ProductGrid = ({ products, loading, columns = 4, listContextKey = '' }) => {
  const gridCols = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5',
    6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6',
    8: 'grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8',
  };
  
  // Use smaller gap for more columns
  const gapClass = columns >= 6 ? 'gap-2 sm:gap-3' : 'gap-4 sm:gap-6';

  if (loading) {
    return (
      <div className={`grid ${gridCols[columns]} ${gapClass}`} data-testid="product-grid-loading">
        {[...Array(columns >= 6 ? 32 : 8)].map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="aspect-square rounded-xl" />
            <Skeleton className="h-3 w-2/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-16" data-testid="product-grid-empty">
        <p className="text-muted-foreground">No products found</p>
      </div>
    );
  }

  return (
    <div className={`grid ${gridCols[columns]} ${gapClass}`} data-testid="product-grid">
      {products.map((product, index) => (
        <ProductCard
          key={listContextKey ? `${listContextKey}::${product.id}::${index}` : `${product.id}::${index}`}
          product={product}
          compact={columns >= 6}
        />
      ))}
    </div>
  );
};
